import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share'
import { SocialShareWrapper } from './ShareButtons.styles'
import { useElementClick } from '@/hooks/HTMLElementClickHook'
import { CSSProperties } from 'react'

type ShareButtonsProps = {
  url: string
}

const ShareButtons: React.FC<ShareButtonsProps> = ({ url }) => {
  const linkClick = useElementClick('Link')
  const bgStyle: CSSProperties = { fill: 'transparent', stroke: 'black', strokeWidth: '2px' }
  const location = 'PDP | Social Share'

  return (
    <SocialShareWrapper>
      <FacebookShareButton
        url={url}
        onClick={(event) => linkClick({ location, event, text: 'Facebook Share' })}
        aria-label="Share on Facebook"
        data-testid="fb-share-button"
      >
        <FacebookIcon bgStyle={bgStyle} iconFillColor="black" size={32} round />
      </FacebookShareButton>
      <WhatsappShareButton
        url={url}
        onClick={(event) => linkClick({ location, event, text: 'Whatsapp Share' })}
        aria-label="Share on Whatsapp"
        data-testid="whatsapp-share-button"
      >
        <WhatsappIcon bgStyle={bgStyle} iconFillColor="black" size={32} round />
      </WhatsappShareButton>
      <TwitterShareButton
        url={url}
        onClick={(event) => linkClick({ location, event, text: 'Twitter Share' })}
        aria-label="Share on X"
        data-testid="x-share-button"
      >
        <TwitterIcon bgStyle={bgStyle} iconFillColor="black" size={32} round />
      </TwitterShareButton>
      <EmailShareButton
        openShareDialogOnClick
        subject="Check out this epic experience"
        body="Thought you'd be interested in this one:"
        url={url}
        onClick={(event) => linkClick({ location, event, text: 'Email Share' })}
        aria-label="Share via e-mail"
        data-testid="email-share-button"
      >
        <EmailIcon bgStyle={bgStyle} iconFillColor="black" size={32} round />
      </EmailShareButton>
    </SocialShareWrapper>
  )
}


export default ShareButtons
